module.exports = __webpack_public_path__ + "static/media/productos-pro.a9a3e73a.svg";